import DOMPurify from 'dompurify'

const separators: Record<string, string> = {
  p: '\n\n',
  div: '\n\n',
  ul: '\n\n',
  ol: '\n\n',
  table: '\n\n',
  br: '\n',
  li: '\n',
  tr: '\n',
  td: ' | ',
  th: ' | ',
}

function appendPlainText(node: Node, parts: string[]): void {
  if (node.nodeType === Node.TEXT_NODE) {
    parts.push(node.textContent ?? '')
    return
  }
  if (!(node instanceof Element)) return
  if (node.localName === 'li') parts.push('\n• ')
  node.childNodes.forEach((child) => appendPlainText(child, parts))
  parts.push(separators[node.localName] ?? '')
}

export function workOrderPlainText(value: string): string {
  const fragment = DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [...Object.keys(separators), 'tbody', 'thead', 'tfoot'],
    ALLOWED_ATTR: [],
    RETURN_DOM_FRAGMENT: true,
  })
  const parts: string[] = []
  fragment.childNodes.forEach((node) => appendPlainText(node, parts))
  return parts
    .join('')
    .replace(/[ \t\u00a0]+/g, ' ')
    .split('\n')
    .map((line) => line.trim().replace(/\s*\|$/, ''))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function normalizeWorkOrderText(value: string): string {
  return value
    .toLocaleLowerCase()
    .replace(/[:•]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}
